import React, { useEffect, useState } from 'react'
import { useAuth } from '../../context/auth-context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { rootUrl } from '../../helpers';
import DataTable from 'react-data-table-component';
import { FaEdit, FaThumbsUp } from 'react-icons/fa';
import FormGenerator from '../../components/formGenerator';
import ModalDefault from '../../components/ModalDefault';
import ModalSmall from '../../components/modalSmall';

export default function Users() {

   const auth = useAuth()

   const [users, setUsers] = useState([]);
   const [roles, setRoles] = useState([]);

    const fetchData = async () => {
        try {
          const data = await axios.get(rootUrl(`/getUsers/${auth.user.cid}`));
          if (data.status === 200) {
            setUsers(data.data.data.biodata);
          }
        } catch (e) {
          toast.error(e?.message);
        }


        try {
          const data = await axios.get(rootUrl(`/getRoles`));
          if (data.status === 200) {
            setRoles(data.data.data);
            console.log(data.data.data)
          }
        } catch (e) {
          toast.error(e?.message);
        }
      };
    
      useEffect(()=>{
        fetchData()

       

      }, [])

      const [modal, setModal] = useState({title: '', open: false, body: '', size: 'sm'});
        

      const handleClose = () => {
        setModal({...modal, open: false });   
      };
    
      const columns = [
        { name: 'Email', selector: row => row.email, sortable: true },
        { name: 'First Name', selector: row => row.firstName +' '+row.lastName, sortable: true },
        { name: 'Phone Number', selector: row => row.phoneNumber, sortable: true },
        { name: 'Date of Birth', selector: row => row.dob, sortable: true },
        { name: 'Gender', selector: row => row.gender, sortable: true },
        { name: 'Roles', selector: row => row.rid!== null?roles?.find(a=>a.id === row.rid)?.name:'No Roles', sortable: true },
        { name: 'Status', cell:row=>row.mode == 0?'Pending':'Approved' },
        {
          name: 'Actions',
          cell: row => row.mode == 0? <button className='text-green-500' onClick={() => handleApprove(row.userId)}> <FaThumbsUp /> </button>:<button className='text-green-500' onClick={() => handleRoles(row.userId)}> <FaEdit /> </button>,
          button: true
        }
      ];
      const handleApprove = async (id) => {
        try {
            const data = await axios.get(rootUrl(`/approve/${id}`));
            if (data.status === 200) {
                toast.success("Successful");
                fetchData()
            }
          } catch (e) {
            toast.error(e?.message);
          }
      };

      let uid = ''

      const onsubmit = async(formdata)=>{

        formdata['uid'] = uid;

        try {
          const data = await axios.post(rootUrl(`/giveRole`), formdata);
          if (data.status === 200) {
              toast.success("Successful");
              fetchData()
              handleClose()
          }
        } catch (e) {
          toast.error(e?.message);
        }

      }

      function handleRoles(id){
        
        uid = id
        setModal({
          title: 'Update User Role',
          open: true,
          size: 'sm',
          body:<> <FormGenerator  fields={[
            {type: 'select', name: 'rid', label: 'Roles', required: true, options: roles.map(res => ({
              value: res.id,
              label: res.name,
            }))}]
          } onSubmit={onsubmit} /> 
           </>
          
        });



      }

     
    

  return (
    <div>
        <DataTable
        title="User List"
        columns={columns}
        data={users}
        pagination
        highlightOnHover
        pointerOnHover
      />

      <ModalSmall title={modal.title} size={modal.size} open={modal.open} onClose={handleClose} body={modal.body} />
    </div>
  )
}

